<svg [attr.width]="this.width" [attr.height]="this.height" [attr.viewBox]="('0 0 ' + this.width + ' ' + this.height)" aria-labelledby="svg-title" xmlns="http://www.w3.org/2000/svg">
  <title id="svg-title">{{this.alt}}</title>
  <style>
    .spinner-path {
      transform-origin: 50% 50%;
      animation: spin 1.2s linear infinite;
      stroke: #333; /* Default color, change this */
      stroke-width: 4;
      fill: none;
      stroke-linecap: round;
      stroke-dasharray: 80, 150; /* Adjusts the gap and line segment */
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    svg{
      padding-top: 5px;
      padding-bottom: 5px;
    }
  </style>
  <circle class="spinner-path" cx="20" cy="20" r="16" />
</svg>